import apiConfig from "../config";
import { FooterType } from "../../Types/FooterType";

type Response = {
	data: FooterType;
};

const footerApi = (): Promise<FooterType> => {
	return apiConfig()
		.get<Response>(`/footer`)
		.then(({ data }) => {
			return data.data;
		})
		.catch(({ data }) => {
			return data;
		});
};

export default footerApi;
